class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
    //refreshCartIconBubble();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);


// --- ここからカートAjax処理部分 ---
function fetchAndUpdateCartIcon() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const itemCount = cart.item_count;
      const totalPrice = (cart.total_price / 100).toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' });
      const icon = document.querySelector('#header__icon--cart-icon-bubble');
      if (!icon) return;

      // ======= ここからカウントバブルの強制生成！ =======
      let countBubble = icon.querySelector('.header__icon--cart-count-bubble');
      if (!countBubble && itemCount > 0) {
        // バブルがなければ作る
        countBubble = document.createElement('div');
        countBubble.className = 'header__icon--cart-count-bubble';
        countBubble.innerHTML = `
          <span aria-hidden="true">${itemCount}</span>
          <span class="visually-hidden">カートに${itemCount}個</span>
        `;
        icon.appendChild(countBubble);
      }
      if (countBubble) {
        const countSpan = countBubble.querySelector('span[aria-hidden="true"]');
        if (itemCount > 0) {
          countBubble.style.display = '';
          if (countSpan) countSpan.textContent = itemCount;
        } else {
          countBubble.style.display = 'none';
        }
      }
      // ======= ここまでバブル処理 =======

      // 既存の金額表示処理（前に書いたやつそのまま使ってOK）

      let priceDiv = icon.querySelector('.header__icon--cart-total-price');
      if (!priceDiv && itemCount > 0) {
        priceDiv = document.createElement('div');
        priceDiv.className = 'header__icon--cart-total-price';
        priceDiv.innerHTML = `<span aria-hidden="true">${totalPrice}</span>`;
        icon.appendChild(priceDiv);
      }
      if (priceDiv) {
        const priceSpan = priceDiv.querySelector('span[aria-hidden="true"]');
        if (itemCount > 0) {
          priceDiv.style.display = '';
          if (priceSpan) priceSpan.textContent = totalPrice;
        } else {
          priceDiv.style.display = 'none';
        }
      }

      if (itemCount > 0) {
        icon.classList.add('header__icon--cart--in');
      } else {
        icon.classList.remove('header__icon--cart--in');
      }
    });
}
window.addEventListener('cart:updated', function(){
  fetchAndUpdateCartIcon();
});
